import React from 'react';
import '../../assets/styles/site/_edit.scss';
import useAPI from "../../utils/api";
import SiteForm from "./SiteInfo/SiteForm";
import { useSnackbar } from 'notistack';
import { useRoleCheck } from '../../utils/useRoleCheck';

function SiteInfo({ site }) {
  const API = useAPI();
  const handleRoleCheck = useRoleCheck(API.currentRole);
  const { enqueueSnackbar } = useSnackbar();

  const updateSite = async (form) => {
    // To check allowed role to perform action
    if (handleRoleCheck()) { return; }
    const previousSpamShield = site.spam_shield_enabled;
    const [ok, updated] = await API.updateSite(form);
    if (!ok && updated?.field === 'url') {
      // The API's banned-domain message is playful; settings shows a plain one instead.
      const isFormatError = updated.message?.startsWith('Enter a valid website address');
      return {
        urlError: isFormatError
          ? updated.message
          : "This website address can't be used. Please enter your own website's address."
      };
    }
    if (updated) {
      site.update(updated);
      const spamShieldRolledBack = form.spam_shield_enabled !== undefined &&
        !!updated.spam_shield_enabled !== !!form.spam_shield_enabled;
      const spamShieldChanged = form.spam_shield_enabled !== undefined &&
        !!form.spam_shield_enabled !== !!previousSpamShield;

      if (spamShieldRolledBack) {
        enqueueSnackbar('Settings saved. However, Spam Shield update failed. Please try again or contact our support team.', {
          variant: 'error',
          preventDuplicate: true,
        });
      } else if (spamShieldChanged && updated.spam_shield_enabled) {
        enqueueSnackbar('Settings saved. Spam Shield has been enabled successfully.', {
          variant: 'success',
          preventDuplicate: true,
        });
      } else if (spamShieldChanged && !updated.spam_shield_enabled) {
        enqueueSnackbar('Settings saved. Spam Shield has been disabled and will remain active until the end of your billing cycle.', {
          variant: 'info',
          preventDuplicate: true,
        });
      } else {
        enqueueSnackbar('Settings saved successfully.', {
          variant: 'success',
          preventDuplicate: true,
        });
      }
    }
    return updated;
  }

  const deleteSite = async () => {
    // To check allowed role to perform action
    if (handleRoleCheck()) { return; }
    await API.deleteSite(site);
    window.location.pathname = "/";
  }

  return (
    <div id="sites-edit" style={{ 'padding': '24px' }}>
      <div className="edit_site">
        <SiteForm 
          site={site} 
          onSubmit={updateSite} 
          onSiteDelete={deleteSite}
        />
      </div>
    </div>
  )
}

export default SiteInfo;
